<template>
  <v-list class="py-0" color="kbLight">
    <v-tooltip right
               nudge-right="-5px"
               :disabled="!minimizedSideMenu"
               v-for="(item, index) in listItems"
               :key="index">
      <template v-slot:activator="{ on }">
        <v-list-item @click="changeCurrentComponent(item.component)"
                     class="kbLight"
                     :class="[currentComponent === item.component ? 'list-item-active' : '',
                              minimizedSideMenu && !$vuetify.breakpoint.smAndDown ? 'justify-center px-1' : 'px-3']"
                     v-on="on">
          <v-list-item-action :style="{ marginRight: minimizedSideMenu && !$vuetify.breakpoint.smAndDown ? '0px!important' : '32px!important' }">
            <v-icon :color="item.icon.color || 'kbDarkBlueText'"
                    size="28px">
              {{ item.icon.name }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-title class="kbDarkBlueText--text" v-show="!minimizedSideMenu || $vuetify.breakpoint.smAndDown">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
      <span>{{ item.title }}</span>
    </v-tooltip>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['businessModule']),
    listItems () {
      return [
        { component: 'Profile', icon: { name: 'mdi-account-outline', color: 'kbPink' }, title: this.$t('general.profile') },
        { component: 'Preferences', icon: { name: 'feather-trending-up', color: 'kbLightBlue' }, title: this.$t('general.likes') },
        // { component: 'Calls', icon: { name: 'mdi-phone', color: 'kbGreen' }, title: this.$t('general.calls') },
        { component: 'ListPicker', icon: { name: 'mdi-format-list-text', color: 'kbBlue' }, title: this.$t('general.lists') },
        { component: 'Tasks', icon: { name: 'mdi-calendar-check-outline', color: 'kbGreen' }, title: this.$t('general.tasks') },
        { component: 'UserJourney', icon: { name: 'mdi-file-tree', color: 'kbLightBlue' }, title: this.$t('general.journey') },
        { component: 'Businesses', icon: { name: 'feather-dollar-sign', color: 'kbRed' }, title: this.businessModule.p },
        { component: 'Documents', icon: { name: 'mdi-file-document-outline', color: 'kbDarkBlueText' }, title: this.$t('general.documents') },
        { component: 'SetResponsible', icon: { name: 'mdi-account-check', color: 'kbRed' }, title: this.$t('general.setResponsible') },
        { component: 'Notes', icon: { name: 'mdi-note-multiple-outline', color: 'kbPink' }, title: this.$t('general.notes') },
        { component: 'Actions', icon: { name: 'mdi-bell-outline', color: 'kbGold' }, title: this.$t('general.actions') }
      ]
    }
  },
  methods: {
    changeCurrentComponent (component) {
      this.$emit('changeCurrentComponent', component)
    },
    toggleModal () {
      this.$emit('toggleModal', false)
    }
  },
  props: {
    currentComponent: {
      type: String,
      required: true
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    }
  }
}
</script>
